// write a signleton service that uses keycloak adapter that is used for authentication 
// and authorization.

import Keycloak from 'keycloak-js';
import Core from 'hvx/modules/CoreModule';
console.log('KCService');
const authenticatedEvt = 'hvx.user.authenticated';
const requiredRoles = ['ROLE_USER', 'ROLE_APPROVED'];
export default class KCService {
  constructor() {
    console.log('KCService');
    if (KCService.instance) {
      return KCService.instance;
    }
    KCService.instance = this;
    this.keycloak =new Keycloak({
      // eslint-disable-next-line no-undef
      url: `${ENVS_AUTH_URL}`,
      // eslint-disable-next-line no-undef
      realm: `${ENVS_AUTH_REALM}`,
      // eslint-disable-next-line no-undef
      clientId: `${ENVS_AUTH_CLIENT_ID}`,
            
    });
        
    return this;
  }
  async init() {
    try {
      const authenticated = await this.keycloak.init({
        onLoad: 'login-required',
        // checkLoginIframeadm: false,
        // flow: 'implicit',
        // responseMode:'query',
        enableLogging: true,
        // useNonce: false,
      });
      if (!authenticated) {
        return false;
      }
      if (!this.hasRequiredRoles()) {
        this.redirectUnauthorized();
        return false;
      }
      Core.EventManager.fireEvent(authenticatedEvt);
      console.log(`User is ${authenticated ? 'authenticated' : 'not authenticated'}`);
      return true;
    } catch (error) {
      console.error('Failed to initialize adapter:', error);
      return false;
    }
  }

  getRealmRoles() {
    const tokenParsedRoles = this.keycloak && this.keycloak.tokenParsed &&
      this.keycloak.tokenParsed.realm_access &&
      Array.isArray(this.keycloak.tokenParsed.realm_access.roles)
      ? this.keycloak.tokenParsed.realm_access.roles
      : [];
    const realmAccessRoles = this.keycloak && this.keycloak.realmAccess &&
      Array.isArray(this.keycloak.realmAccess.roles)
      ? this.keycloak.realmAccess.roles
      : [];
    return tokenParsedRoles.length ? tokenParsedRoles : realmAccessRoles;
  }

  hasRequiredRoles() {
    const normalizedRoles = new Set(this.getRealmRoles().map((role) => role.toUpperCase()));
    return requiredRoles.every((requiredRole) => normalizedRoles.has(requiredRole));
  }

  getUnauthorizedRedirectUrl() {
    const segments = window.location.pathname.split('/').filter(Boolean);
    const contextPath = segments.length > 1 ? `/${segments[0]}` : '';
    return `${window.location.origin}${contextPath}/unauthenticated.html`;
  }

  redirectUnauthorized() {
    const unauthorizedPath = '/unauthenticated.html';
    if (window.location.pathname.endsWith(unauthorizedPath)) {
      return;
    }
    window.location.replace(this.getUnauthorizedRedirectUrl());
  }
  getToken() {
    return this.keycloak;
  }
    
  logout() {
    this.keycloak.logout();
  }
}
